<template>
  <div>
    <GmapMap
      v-if="hasGeoData"
      ref="mapRef"
      :center="{ lat: lat, lng: lng }"
      :zoom="zoom"
      map-type-id="terrain"
      style="width: 520px; height: 500px"
    >
      <GmapInfoWindow
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened = false"
      >
        <FirmDetail :firm="infoFirm" :logoHost="logoHost" :map="true" />
      </GmapInfoWindow>
      <GmapMarker
        :key="index"
        v-for="(m, index) in firms"
        :position="markerPosition(m)"
        :clickable="true"
        :draggable="true"
        @click="showInfo(m)"
      />
    </GmapMap>
  </div>
</template>

<script>
import FirmDetail from '@/components/FirmDetail'
import GmapMap from 'vue2-google-maps/src/components/map'
import GmapInfoWindow from 'vue2-google-maps/src/components/infoWindow'
import GmapMarker from 'vue2-google-maps/src/components/marker'
// import { gmapApi } from 'vue2-google-maps'
import dottie from 'dottie'

export default {
  components: {
    FirmDetail,
    GmapMap,
    GmapInfoWindow,
    GmapMarker
  },
  props: {
    firms: {
      type: Array
    },
    selected: {
      type: Object
    }
  },
  data() {
    return {
      zoom: 11,
      markers: [],
      infoFirm: {},
      infoPosition: null,
      infoOpened: false
    }
  },
  computed: {
    lng() {
      const lng = dottie.get(this.selected, 'longitude', 0)
      return parseFloat(lng)
    },
    lat() {
      const lat = dottie.get(this.selected, 'latitude', 0)
      return parseFloat(lat)
    },
    hasGeoData() {
      return this.lng !== 0 && this.lat !== 0
    },
    logoHost() {
      return process.env.VUE_APP_API_HOST
    }
  },
  watch: {
    selected: {
      handler: function(value) {
        this.showInfo(value)
      },
      deep: true
    }
  },

  created() {
    if (this.$refs.mapRef === undefined) {
      setTimeout(this.showInfo, 400, this.selected)
    } else {
      this.showInfo(this.selected)
    }
  },

  methods: {
    renderMap() {},
    markerPosition(marker) {
      return (
        window.google &&
        new window.google.maps.LatLng(
          parseFloat(marker.latitude),
          parseFloat(marker.longitude)
        )
      )
    },
    async showInfo(firm) {
      this.infoPosition = await this.markerPosition(firm)
      this.$refs.mapRef.$mapPromise.then(this.openInfo(firm))
    },
    openInfo(firm) {
      this.infoFirm = firm
      this.infoOpened = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
